import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { PendingUser } from '@simultrain/shared';
import { api } from '../api/client.js';

export function PendingUsersPage() {
  const { t } = useTranslation();
  const [pending, setPending] = useState<PendingUser[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busyId, setBusyId] = useState<string | null>(null);

  useEffect(() => {
    void api.listPendingUsers().then(setPending).catch((e) => setError(String(e)));
  }, []);

  async function approve(id: string) {
    setBusyId(id);
    try {
      await api.approvePendingUser(id);
      setPending((prev) => prev?.filter((u) => u.id !== id) ?? prev);
    } catch (e) {
      setError(String(e));
    } finally {
      setBusyId(null);
    }
  }

  async function reject(id: string) {
    if (!window.confirm(t('pendingUsers.rejectConfirm'))) return;
    setBusyId(id);
    try {
      await api.rejectPendingUser(id);
      setPending((prev) => prev?.filter((u) => u.id !== id) ?? prev);
    } catch (e) {
      setError(String(e));
    } finally {
      setBusyId(null);
    }
  }

  return (
    <div style={{ maxWidth: 720 }}>
      <Link to="/projects" className="muted" style={{ fontSize: 13 }}>
        ← {t('projects.title')}
      </Link>
      <h2>{t('pendingUsers.title')}</h2>
      <p className="muted" style={{ fontSize: 13 }}>{t('pendingUsers.hint')}</p>

      {error && <div className="error-banner">{error}</div>}

      {!pending && <div className="empty">…</div>}
      {pending && pending.length === 0 && <div className="empty">{t('pendingUsers.empty')}</div>}
      {pending?.map((u) => (
        <div key={u.id} className="card" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <strong>{u.displayName}</strong>
            <div className="muted" style={{ fontSize: 13 }}>{u.email}</div>
          </div>
          <div className="row" style={{ gap: 8 }}>
            <button disabled={busyId === u.id} onClick={() => void approve(u.id)}>
              {t('pendingUsers.approve')}
            </button>
            <button
              className="danger"
              disabled={busyId === u.id}
              onClick={() => void reject(u.id)}
            >
              {t('pendingUsers.reject')}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
